<template>
    <div>
        <v-container max-width="1500" style="max-width: 1500px !important">
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 2rem !important;">
                <!-- <v-card v-model="dialogHistograma" v-if="dialogHistograma" :style="popupStyles" class="popup-window">
                    <Histograma @closeHistograma="closeHistograma" :hoveredItem="hoveredItem" :fechaDialog="date">
                    </Histograma>
                </v-card> -->
                <v-card v-model="dialogHistorial" v-if="dialogHistorial" :style="popupStyles" class="popup-window">
                    <Historial @closeHistorial="closeHistorial" :hoveredItem="hoveredItem" :fechaDialog="date">
                    </Historial>
                </v-card>
                <v-system-bar class="py-5 px-3 system-bar-title" dark>
                    Protocolo nutrición
                    <v-tooltip bottom color="success">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="green" v-bind="attrs" v-on="on" dark @click="exportExcel"
                                style="margin: 1rem 0;height: 1.9rem;">
                                <v-icon color="white" style="font-size: 1.5rem;">mdi-download-box</v-icon>
                            </v-btn>
                        </template>
                        <span>Descargar</span>
                    </v-tooltip>
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 2rem !important;">
                <v-row style="padding: 1rem;">
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchSubactividad" label="Paciente"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-text-field max-width="200" class="mx-3" v-model="searchDNI" label="DNI"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-text-field max-width="200" class="mx-3" v-model="searchAutogenerado" label="Autogenerado"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="date" label="Periodo" append-icon="mdi-calendar" outlined dense
                                    readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="date" type="month" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modal = false">
                                    Cancel
                                </v-btn>
                                <v-btn text color="primary" @click="saveDate">
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" lg="2" md="2">
                        <v-select max-width="200" class="mx-3" v-model="searchSala" label="Sala"
                            append-icon="mdi-magnify" outlined dense multiple item-text="label" item-value="value"
                            :items="salasItems"></v-select>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" style=" margin:0 auto;padding: 1.5rem;">
                <v-row>
                    <v-col cols="6" sm="3" md="3" style="padding-top:0 !important;">
                        <!-- <v-btn color="blue" dark class="mb-2" @click="openForm" style="margin: 1rem 0;">
                            Nuevo
                        </v-btn> -->
                        <v-btn color="blue" dark class="mb-2" @click="statusEdit = !statusEdit" v-if="statusEdit"
                            style="margin: 1rem 1rem;">
                            Editar
                        </v-btn>
                        <v-btn color="blue" v-if="!statusEdit" dark class="mb-2" @click="save"
                            style="margin: 1rem 1rem;">
                            Guardar
                        </v-btn>
                    </v-col>
                </v-row>

                <div>
                    <v-data-table ref="table" dense :headers="filteredHeaders" :items="filteredData" class="table-style"
                        :loading="isLoading" loading-text="Cargando... Por favor espere">
                        <!-- </tr> -->
                        <template v-slot:[`item.MASA_CORPORAL`]="{ item }">
                            <v-select v-model="item.MASA_CORPORAL" @change="onInputChange(item,'MASA_CORPORAL_BAN')" hide-details dense
                                style="text-align: center !important;"  :items="['Sí','No']"
                                :disabled="statusEdit" :class="{'color-gery': item.MASA_CORPORAL_BAN == '1'}"></v-select>
                        </template>
                        <template v-slot:[`item.MASA_MUSCULAR`]="{ item }">
                            <v-select v-model="item.MASA_MUSCULAR" :items="['Sí','No']"  @change="onInputChange(item,'MASA_MUSCULAR_BAN')" hide-details dense
                            style="text-align: center;" :disabled="statusEdit" :class="{'color-gery': item.MASA_MUSCULAR_BAN == '1'}"></v-select>
                        </template>
                        <template v-slot:[`item.INGESTA_PROT_CAL`]="{ item }">
                            <v-select v-model="item.INGESTA_PROT_CAL" :items="['Sí','No']" @change="onInputChange(item,'INGESTA_PROT_CAL_BAN')" hide-details dense
                                style="text-align: center;" :disabled="statusEdit" :class="{'color-gery': item.INGESTA_PROT_CAL_BAN == '1'}"></v-select>
                        </template>
                        <template v-slot:[`item.BIOQUIMICA`]="{ item }">
                            <v-select v-model="item.BIOQUIMICA" :items="['Sí','No']" @change="onInputChange(item,'BIOQUIMICA_BAN')" hide-details dense
                                style="text-align: center;" :disabled="statusEdit" :class="{'color-gery': item.BIOQUIMICA_BAN == '1'}"></v-select>
                        </template>
                        <template v-slot:[`item.TOTAL_CRITERIOS`]="{ item }">
                            <v-text-field v-model="item.TOTAL_CRITERIOS" @input="onInputChange(item,'TOTAL_CRITERIOS_BAN')" hide-details dense
                                style="text-align: center;" :disabled="true" :class="{'color-gery': item.TOTAL_CRITERIOS_BAN == '1'}"></v-text-field>
                        </template>
                        <template v-slot:[`item.DIAGNOSTICO`]="{ item }">
                            <v-select v-model="item.DIAGNOSTICO" :items="['Riesgo','DPE','Normal']" @input="onInputChange(item,'DIAGNOSTICO_BAN')" hide-details dense
                                style="text-align: center;" :disabled="statusEdit" :class="{'color-gery': item.DIAGNOSTICO_BAN == '1'}"></v-select>
                        </template>
                        <template v-slot:[`item.SNO`]="{ item }">
                            <v-text-field v-model="item.SNO" @input="onInputChange(item,'SNO_BAN')" hide-details dense
                                style="text-align: center;" :disabled="statusEdit" :class="{'color-gery': item.SNO_BAN == '1'}"></v-text-field>
                        </template>
                        <template v-slot:[`item.ADMINISTRACION`]="{ item }">
                            <v-select v-model="item.ADMINISTRACION" :items="['Intradialítica','Domiciliaria']" @input="onInputChange(item,'ADMINISTRACION_BAN')" hide-details dense
                                style="text-align: center;" :disabled="statusEdit" :class="{'color-gery': item.ADMINISTRACION_BAN == '1'}"></v-select>
                        </template>
                        <template v-slot:[`item.OBSERVACIONES`]="{ item }">
                            <v-text-field v-model="item.OBSERVACIONES" @input="onInputChange(item)" hide-details dense
                                style="text-align: center;" :disabled="statusEdit"></v-text-field>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon  style="cursor:pointer" color=#009f99 @click="openHistorial($event, item)">mdi-information</v-icon>
                        </template>
                    </v-data-table>
                </div>
            </v-card>
            <v-dialog v-model="dialogLoader" persistent width="300"
                style="padding: 1rem;overflow: hidden !important;background: white !important;">
                <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
            </v-dialog>
        </v-container>
    </div>
</template>
<style scoped>
.layout-loading {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 202;
    background: #e3e3e3b1;
}

::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

::v-deep .v-overlay__scrim {
    opacity: 1 !important;
    background-color: rgba(240, 240, 240, 0.54) !important;
    border-color: rgb(255 255 255) !important;
}

.system-bar-title {
    display: flex;
    justify-content: space-between;
    color: white;
    padding: 1.2rem 1.4rem !important;
}

.add-column {
    position: absolute;
    left: -10%;
    height: 1.2rem;
    width: 1.2rem;
    bottom: -85%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
}

.minus-column {
    position: absolute;
    left: -10%;
    height: 1.2rem;
    width: 1.2rem;
    bottom: -85%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
}

::v-deep .table-style table tr:hover .add-column {
    display: flex !important;
    cursor: pointer;
}

::v-deep .table-style table tr:hover .minus-column {
    display: flex !important;
    cursor: pointer;
}

.popup-window {
    width: 20rem;
    position: absolute;
    background-color: white;
    border: 1px solid #ccc;
    padding: 1rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

::v-deep .v-text-field.v-input--dense:not(.v-text-field--outlined) input {
    text-align: center !important;
}

::v-deep tr th {
    text-wrap: nowrap !important;
}

::v-deep tr td {
    text-wrap: nowrap !important;
}

::v-deep .v-card {
    box-shadow: 0px 0px 11px 6px rgb(15 61 99 / 27%) !important;
}

::v-deep .v-btn {
    text-transform: capitalize !important;
}

::v-deep .theme--dark.v-system-bar {
    background: #1780cd;
    color: white;
    font-size: 600;
}

.custom-btn {
    width: 32px !important;
    height: 32px !important;
}

.custom-icon {
    font-size: 20px !important;
}

.bg-primary-table {
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}

td {
    white-space: nowrap;
}

::v-deep .highlight-column {
    background-color: #f0f0f0 !important;
    /* Color de fondo para las columnas visibles */
    transition: background-color 0.3s ease;
    /* Añade una transición suave */
}
::v-deep .theme--light.v-input.color-gery input {
    color: rgba(216, 18, 18, 0.87);
}
::v-deep .color-gery .theme--light.v-select .v-select__selections {
    color: rgba(172, 12, 12, 0.87);
}
::v-deep .color-gery .theme--light.v-select .v-select__selection--disabled {
    color: rgba(211, 2, 2, 0.38);
}
.color-gery .theme--light.v-select .v-select__selection--disabled {
    color: rgba(170, 11, 11, 0.38);
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
import Historial from "./historial.vue"

export default {
    data() {
        return {
            dialogHistorial:false,
            dialogLoader: false,
            searchAutogenerado: null,
            searchSala: [],
            dialogForm: false,
            statusEdit: true,
            statusViewColumnHB: false,
            popupVisible: false,
            hoveredItem: null,
            popupStyles: {
                top: '-8000px',
                left: '0px'
            },
            salasItems:[
                {label:"Clínicas",value:"0"},
                {label:"S1 CNSR",value:"1"},
                {label:"S2 CNSR",value:"2"},
                {label:"S3 CNSR",value:"3"},
                {label:"S4 CNSR",value:"4"},
                {label:"S5 DP",value:"5"}
            ],
            dialogHistograma: false,
            date: new Date().toISOString().slice(0, 7),
            modal: false,
            searchSubactividad: null,
            searchDNI: null,
            dialogLoader: false,
            dataPaciente: [],
            search: "",
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "SALA", value: "SALA", align: "center" },
                { text: "AUTOGENERADO", value: "AUTOGENERADO", align: "center" },
                { text: "PACIENTE", value: "PACIENTE", align: "center" },
                { text: "NUM DOC", value: "NUM_DOC", align: "center" },
                { text: "ALBUMINA", value: "ALBUMINA", align: "center" },
                { text: "MASA CORPORAL", value: "MASA_CORPORAL", align: "center" },
                { text: "MASA MUSCULAR", value: "MASA_MUSCULAR", align: "center" },
                { text: "INGESTA PROT CAL", value: "INGESTA_PROT_CAL", align: "center" },
                { text: "BIOQUIMICA", value: "BIOQUIMICA", align: "center" },
                { text: "TOTAL CRITERIOS", value: "TOTAL_CRITERIOS", align: "center" },
                { text: "DIAGNOSTICO", value: "DIAGNOSTICO", align: "center" },
                { text: "SNO (UNIDADES POR SEMANA)", value: "SNO", align: "center" },
                { text: "ADMINISTRACION", value: "ADMINISTRACION", align: "center" },
                { text: "OBSERVACIÓN", value: "OBSERVACIONES", align: "center" },
                { text: "ACCIONES", value: "actions", align: "center" }
            ],
            dialogEdit: false,
            dialogDelete: false,
            isLoading: false,
            itemsTipSex: ["MASCULINO", "FEMENINO"],
            menu: false,
            selectedColumns: ['PACIENTE',
                'NUM_DOC',
                'ALBUMINA',
                'MASA_CORPORAL',
                'MASA_MUSCULAR',
                'INGESTA_PROT_CAL',
                'BIOQUIMICA',
                'TOTAL_CRITERIOS',
                'DIAGNOSTICO',
                'SNO',
                'ADMINISTRACION',
                'SALA',
                'AUTOGENERADO', 'OBSERVACIONES','actions'],
            itemMes: null,
            itemPeriodo: null,
            statusViewColumn: false,
            dataArray: []
        };
    },
    methods: {
        openHistorial(event, item){
            this.hoveredItem = item;
            this.dialogHistorial=true;
        },
        closeHistorial(){
            this.dialogHistorial=false;
        },
        openForm() {
            this.dialogForm = true;
        },
        closeForm() {
            this.dialogForm = false;
        },
        save() {
            for (let i = 0; i < this.dataArray.length; i++) {
                this.dialogLoader = true;
                const element = this.dataArray[i];
                axios
                    .post(RUTA_API + "/api/token/", {
                        username: USUARIO,
                        password: PASSWORD,
                    })
                    .then((response) => {
                        this.auth = "Bearer " + response.data.access;
                        axios
                            .post(RUTA_API + "/generar_actualizar_protocolo_nutricion/", { "ID": element.ID, "MASA_CORPORAL": element.MASA_CORPORAL, "MASA_MUSCULAR": element.MASA_MUSCULAR, "INGESTA_PROT_CAL": element.INGESTA_PROT_CAL, "BIOQUIMICA": element.BIOQUIMICA, "TOTAL_CRITERIOS": element.TOTAL_CRITERIOS, "DIAGNOSTICO": element.DIAGNOSTICO, "SNO": element.SNO, "ADMINISTRACION": element.ADMINISTRACION, "OBSERVACIONES": element.OBSERVACIONES, "MASA_CORPORAL_BAN": element.MASA_CORPORAL_BAN,"MASA_MUSCULAR_BAN": element.MASA_MUSCULAR_BAN,"INGESTA_PROT_CAL_BAN": element.INGESTA_PROT_CAL_BAN,"BIOQUIMICA_BAN": element.BIOQUIMICA_BAN,"TOTAL_CRITERIOS_BAN": `${element.TOTAL_CRITERIOS_BAN}`,"DIAGNOSTICO_BAN": element.DIAGNOSTICO_BAN,"SNO_BAN": element.SNO_BAN,"ADMINISTRACION_BAN": element.ADMINISTRACION_BAN}, {
                                headers: { Authorization: this.auth },
                            })
                            .then((res) => {
                                this.dataInit();
                                if (this.dataArray.length == i + 1) {
                                    this.dialogLoader = false;
                                    this.dataArray = [];
                                    this.dialogLoader = false;
                                    this.isLoading = false;
                                    this.dataInit();
                                    this.statusEdit = true;
                                    Swal.fire({
                                        title: "¡Listo!",
                                        text: "Se guardaron los cambios.",
                                        icon: "success",
                                        confirmButtonText: "Aceptar"
                                    });
                                    return;
                                }

                            })
                            .catch((res) => {
                                this.dialogLoader = false;
                                Swal.fire({
                                    title: "¡Error!",
                                    text: error.response.data.error || "No se guardaron los cambios.",
                                    icon: "error",
                                    confirmButtonText: "Aceptar"
                                });
                                return;
                            });
                    })
                    .catch((response) => {
                        this.dialogLoader = false;
                        response === 404
                            ? console.warn("lo sientimos no tenemos servicios")
                            : console.warn("Error:", response);
                    });

            }
            this.statusEdit = true;
        },
        showPopup(event, item) {
            this.hoveredItem = item;
            this.dialogHistograma = true;
            // Ajustar la posición de la ventana emergente según la posición del mouse
            this.popupStyles.top = `${event.clientY - 380}px`;
            this.popupStyles.left = `${event.clientX - 400}px`;
        },
        hidePopup() {
            this.dialogHistograma = false;
            this.hoveredItem = null;
        },
        onMouseOver(valor) {
            this.dialogHistograma = true;
            console.log("valor de lo que asa el mouse por encima", valor.paciente);
        },
        closeHistograma() {
            this.dialogHistograma = false;
        },
        onInputChange(valor,campo) {
            if(campo=='MASA_CORPORAL_BAN'){
                valor.MASA_CORPORAL_BAN = '0';
            }
            if(campo=='MASA_MUSCULAR_BAN'){
                valor.MASA_MUSCULAR_BAN = '0';
            }
            if(campo=='INGESTA_PROT_CAL_BAN'){
                valor.INGESTA_PROT_CAL_BAN = '0';
            }
            if(campo=='BIOQUIMICA_BAN'){
                valor.BIOQUIMICA_BAN = '0';
            }
            if(campo=='TOTAL_CRITERIOS_BAN'){
                valor.TOTAL_CRITERIOS_BAN = '0';
            }
            if(campo=='DIAGNOSTICO_BAN'){
                valor.DIAGNOSTICO_BAN = '0';
            }
            if(campo=='SNO_BAN'){
                valor.SNO_BAN = '0';
            }
            if(campo=='ADMINISTRACION_BAN'){
                valor.ADMINISTRACION_BAN = '0';
            }
            // Contar cuántos campos tienen el valor "Sí"
            let count = 0;
            if (valor.MASA_CORPORAL === 'Sí') count++;
            if (valor.MASA_MUSCULAR === 'Sí') count++;
            if (valor.INGESTA_PROT_CAL === 'Sí') count++;
            if (valor.BIOQUIMICA === 'Sí') count++;

            // Actualizar el campo TOTAL_CRITERIOS
            valor.TOTAL_CRITERIOS = count;
            // Verifica si el array ya existe en `this.dataArray`
            const existe = this.dataArray.some(
                (arr) => JSON.stringify(arr.NUM_DOC) === JSON.stringify(valor.NUM_DOC)
            );


            if (!existe) {
                this.dataArray.push(valor);
            }

        },
        updateItem(valor) {
            console.log("valor de un item expuesto ", valor);
        },
        saveDate() {
            // Ejecuta la lógica adicional
            this.loadPeriodo();
            // Luego ejecuta la función de guardado del diálogo
            this.$refs.dialog.save(this.date);
        },
        loadPeriodo() {
            let [year, month] = this.date.split('-');
            this.itemMes = month;
            this.itemPeriodo = year;
            this.dataInit();
        },
        exportExcel() {
            // Importar xlsx-js-style
            const XLSXStyle = require("xlsx-js-style");

            // Definir cabecera
            const headers = this.selectedColumns.map(column => {
                const header = this.headers.find(h => h.value === column);
                return header ? header.text : column;
            });

            // Convertir datos a formato adecuado para la hoja de cálculo
            const datos = this.filteredData;

            // Inicializar rows con los encabezados
            const rows = [headers];

            // Añadir datos a las filas
            datos.forEach(item => {
                const row = this.selectedColumns.map(column => item[column]);
                rows.push(row);
            });

            // Crear una hoja de cálculo
            const worksheetData = rows;
            const worksheet = XLSXStyle.utils.aoa_to_sheet(worksheetData);
            // Define el rango para el filtro, por ejemplo, desde A1 hasta la última columna de la fila de encabezados

            const rangoFiltro = `A1:${XLSXStyle.utils.encode_col(headers.length - 1)}1`;

            // Agregar el filtro al rango definido
            worksheet['!autofilter'] = { ref: rangoFiltro };
            // Aplicar estilo a las celdas
            // Estilo para el borde de todas las celdas
            const cellStyle = {
                alignment: { horizontal: 'center', vertical: 'center'},  // Centrar texto
                border: {
                    top: { style: 'thin', color: { rgb: '000000' } },
                    bottom: { style: 'thin', color: { rgb: '000000' } },
                    left: { style: 'thin', color: { rgb: '000000' } },
                    right: { style: 'thin', color: { rgb: '000000' } }
                }
            };

            // Estilo específico para la cabecera (relleno plomo, texto blanco)
            const headerStyle = {
                fill: { fgColor: { rgb: "7A7A7A" } },
                font: { color: { rgb: "FFFFFF" }, bold: true },
                alignment: { horizontal: 'center', vertical: 'center', wrapText: true },  // Centrar texto
                border: {
                    top: { style: 'thin', color: { rgb: '000000' } },
                    bottom: { style: 'thin', color: { rgb: '000000' } },
                    left: { style: 'thin', color: { rgb: '000000' } },
                    right: { style: 'thin', color: { rgb: '000000' } }
                }
            };


            // Aplicar estilo a todas las celdas (bordes negros)
            rows.forEach((row, rowIndex) => {
                row.forEach((_, colIndex) => {
                    const cellRef = XLSXStyle.utils.encode_cell({ c: colIndex, r: rowIndex });
                    if (!worksheet[cellRef]) worksheet[cellRef] = {}; // Si la celda no existe, la crea
                    worksheet[cellRef].s = cellStyle; // Aplicar estilo
                });
            });
            //Aplicar filtro a todas las cabeceras
            headers.forEach((header, index) => {
                const cellRef = XLSXStyle.utils.encode_cell({ c: index, r: 0 });
                worksheet[cellRef].s = headerStyle;
            });
            // Crear el libro de trabajo y añadir la hoja
            const workbook = XLSXStyle.utils.book_new();
            XLSXStyle.utils.book_append_sheet(workbook, worksheet, 'Protocolo nutricion');

            // Exportar a archivo Excel
            XLSXStyle.writeFile(workbook, 'Protocolo_nutricion.xlsx');
        },
        dataInit() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_lista_protocolo_nutricion/", { "fecha": this.date }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            this.dataPaciente = res.data;

                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers.filter(header => this.selectedColumns.includes(header.value));
        },
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        filteredData() {
            if (!this.searchSubactividad && !this.searchDNI && !this.searchAutogenerado && this.searchSala.length == 0) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchSubactividad) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = item.PACIENTE;
                    return nombreCompleto.toLowerCase().includes(this.searchSubactividad.toLowerCase());
                });
            }
            if (this.searchDNI) {
                filtered = filtered.filter((item) =>
                    item.NUM_DOC
                        .toLowerCase()
                        .includes(this.searchDNI.toLowerCase())
                );
            }
            if (this.searchAutogenerado) {
                filtered = filtered.filter((item) =>
                    item.AUTOGENERADO
                        .toLowerCase()
                        .includes(this.searchAutogenerado.toLowerCase())
                );
            }
            if (this.searchSala.length !== 0) {
                filtered = filtered.filter((item) =>
                    this.searchSala.some((SALA) =>
                        item.SALA.toLowerCase().includes(SALA.toLowerCase())
                    )
                );
            }
            return filtered;
        },
    },
    created() {
        this.loadPeriodo();
    },
    components: {
        Historial
    },
};
</script>